<template>
  <v-popover
    boundariesElement=".l-main"
    :handleResize="false"
    :placement="placement"
    :popoverClass="popoverClass"
    trigger="hover"
    :disabled="isDisabled"
  >
    <slot></slot>
    <template slot="popover">
      <slot name="popover">
        <slot></slot>
      </slot>
    </template>
  </v-popover>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      required: false
    },
    placement: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  computed: {
    popoverClass() {
      const cssClass = [];
      if (this.size) {
        cssClass.push('c-popover--' + this.size);
      }
      if (this.variant) {
        cssClass.push('c-popover--' + this.variant);
      }
      return cssClass.join(' ');
    }
  }
};
</script>
